import { createApp, reactive } from 'vue' // Import reactive instead of Vue
import App from './App.vue'
import router from './router';
import store from './store'
import '@/services/http'
import './services/http' 
import 'primeicons/primeicons.css';
import './assets/style/main.css';
import './assets/style/popups.css';
import $ from 'jquery'
import 'bootstrap'
import { BASE_API_URL } from '@/config';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import AppHeader from '@/components/header_component.vue'
import PosAppHeader from '@/components/pos_header_component.vue'
import NotyfPlugin from './plugins/notyf';
import { api, setupAxiosInterceptors } from './utils/api';

// Add this permission utility function
const hasPermission = (permissionName) => {
  const permissions = JSON.parse(localStorage.getItem('userPermissions')) || [];
  return permissions.includes(permissionName);
};
window.$ = window.jQuery = $;

// Create a reactive object for global settings
const globalAppSettings = reactive({
  backgroundColor: null
});
window.__globalAppSettings = globalAppSettings;
const app = createApp(App);
app.config.globalProperties.$globalAppSettings = globalAppSettings;
// Provide the global settings to the app
app.config.globalProperties.$globalAppSettings = globalAppSettings;
app.config.globalProperties.$axios = api;
app.config.globalProperties.$BASE_API_URL = BASE_API_URL;
app.config.globalProperties.$hasPermission = hasPermission; 

setupAxiosInterceptors();
app.use(store);
app.use(NotyfPlugin);
app.use(router);
app.component('AppHeader', AppHeader);
app.component('PosAppHeader', PosAppHeader);

app.mount('#app');

window.testLoading = () => {
  store.dispatch('loading/startRequest')
  setTimeout(() => store.dispatch('loading/finishRequest'), 2000)
}